import { Button, ButtonRow, FeaturedProducts, SafeHtml } from 'common';
import Loading from 'components/UI/LoadingScreen/index';
import ScrollToTop from 'components/UI/ScrollToTop';
import { ProductContext, ProductGrid } from 'product';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router';
import { fetchProducerBySlug } from '../../actions';
import AssociatedConcept from '../../components/AssociatedConcept';
import './ProducerPage.scss';
function ProducerPage() {
    const { producerSlug } = useParams();
    const { slug: regionSlug } = useSelector((state) => state.region);
    const { isMobile } = useSelector((state) => state.ui);
    const { products: allProducts } = useSelector((state) => state.products);
    const [producerData, setProducerData] = useState({ type: 'LOADING' });
    // fetch producer data
    useEffect(() => {
        let isSubscribed = true;
        if (regionSlug) {
            fetchProducerBySlug(producerSlug, regionSlug).then((producer) => isSubscribed ? setProducerData(producer) : null);
        }
        return () => {
            isSubscribed = false;
        };
    }, [producerSlug, regionSlug]);
    switch (producerData.type) {
        case 'LOADING':
            return (React.createElement(React.Fragment, null,
                React.createElement(ScrollToTop, null),
                React.createElement(Loading, null)));
        case 'ERROR':
            return React.createElement(Redirect, { to: "/" });
        case 'SUCCESS':
            const producerContent = producerData.data;
            const producerProducts = allProducts.filter((product) => { var _a; return ((_a = product === null || product === void 0 ? void 0 : product.producer) === null || _a === void 0 ? void 0 : _a.id) == producerContent.id; });
            const featuredProducts = allProducts.filter((product) => producerContent.featuredProducts.includes(product.id));
            const MainImageMobile = () => producerContent.backgroundImage && (React.createElement("picture", null,
                React.createElement("source", { type: "image/webp", srcSet: `
                        ${producerContent.backgroundImage.mobile['webp@1x']} 1x,
                        ${producerContent.backgroundImage.mobile['webp@2x']} 2x
                    ` }),
                React.createElement("img", { src: producerContent.backgroundImage.mobile.fallback, className: "producer-page__main-image", alt: "" })));
            const MainImageDesktop = () => producerContent.backgroundImage && (React.createElement("picture", { className: "producer-page__main-image" },
                React.createElement("source", { type: "image/webp", srcSet: `${producerContent.backgroundImage.desktop['webp@1x']} 1x,
                        ${producerContent.backgroundImage.desktop['webp@2x']} 2x` }),
                React.createElement("img", { src: producerContent.backgroundImage.desktop.fallback, className: "producer-page__main-image", alt: "" })));
            return (React.createElement("div", { className: "producer-page" },
                React.createElement(ProductContext.Provider, { value: {
                        context: `ProducerPage_${producerContent.name.replace(' ', '_')}`,
                    } },
                    React.createElement(ScrollToTop, null),
                    isMobile && React.createElement(MainImageMobile, null),
                    React.createElement("div", { className: "producer-page__text-container" },
                        React.createElement("h1", { className: "producer-page__text-container__main-heading" }, producerContent.name),
                        React.createElement(SafeHtml, { type: "div", html: producerContent.entryText, className: "producer-page__text-container__lead-text" }),
                        isMobile && producerContent.associatedConcept && (React.createElement(AssociatedConcept, { concept: producerContent.associatedConcept })),
                        React.createElement(SafeHtml, { type: "div", html: producerContent.description, className: "producer-page__text-container__body-text" })),
                    !isMobile && producerContent.brandLogos.length > 0 && (React.createElement("div", { className: "producer-page__brand-logos" }, producerContent.brandLogos.map((logoSrc) => (React.createElement("img", { key: logoSrc, src: logoSrc, className: "producer-page__brand-logos__logo" }))))),
                    !isMobile && (React.createElement(React.Fragment, null,
                        React.createElement(MainImageDesktop, null),
                        featuredProducts.length > 0 && (React.createElement("div", { className: "producer-page__featured-products" },
                            React.createElement(FeaturedProducts, { featured: featuredProducts }),
                            React.createElement("span", { className: "producer-page__featured-products__text" }, producerContent.featuredProductsDescription))))),
                    producerProducts.length > 0 && (React.createElement("section", { className: "producer-page__products" },
                        React.createElement("h2", { className: "producer-page__products__heading" },
                            producerContent.associatedConcept ? producerContent.associatedConcept.title : 'Produkter',
                            " fra ",
                            producerContent.name),
                        React.createElement(ProductGrid, { products: producerProducts }))),
                    producerContent.associatedConcept && (React.createElement("div", { className: "producer-page__concept-container" },
                        React.createElement("img", { className: "producer-page__concept-container__concept-logo", src: producerContent.associatedConcept.logo }),
                        !isMobile && (React.createElement(React.Fragment, null,
                            React.createElement("h3", { className: "producer-page__concept-container__heading" }, producerContent.associatedConcept.heading),
                            React.createElement("p", { className: "producer-page__concept-container__body-text" }, producerContent.associatedConcept.description))))),
                    React.createElement(ButtonRow, { display: "center", className: 'producer-page__buttons' },
                        React.createElement(Button, { type: "navigation", style: "ghost", to: `/${producerContent.associatedConcept
                                ? producerContent.associatedConcept.identifier
                                : 'products'}` },
                            "G\u00E5 til ",
                            producerContent.associatedConcept ? producerContent.associatedConcept.title : 'alle produkter')))));
    }
}
export default ProducerPage;
